import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    padding: "16px 0px 16px 12px",
    border: "1.5px solid #E7E6E4",
    borderRadius: "8px",
    fontFamily: theme?.typography?.fontFamily,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
  },
  content: {
    width: "100%",
  },
  leftContainer: {},
  rightContainer: {
    marginTop: "-12px",
  },
  mailTo: {
    color: "#272522",
    fontSize: "16px",
    fontWeight: 500,
    textDecoration: "underline",
    marginBottom: ({ isDesktop }) => isDesktop && "12px",
    cursor: "pointer",
    "&:hover": {
      color: theme?.palette?.primary?.main,
    },
  },
  subject: {
    color: "#272522",
    fontSize: "16px",
    marginBottom: "10px",
  },
  dateTime: {
    fontSize: "14px",
    color: "#272522",
    marginBottom: ({ isDesktop }) => !isDesktop && "12px",
  },
  emailIcon: {
    height: "24px",
    width: "24px",
    marginRight: "12px",
  },
  iconButton: {
    padding: "12px",
  },
  deleteIcon: {
    "& :hover": {
      color: theme?.palette?.basic?.danger_red,
    },
  },
  divider: {
    border: "none",
    height: "2px",
    background: "#E7E6E4",
    margin: "10px 0px",
  },
  itemData: {
    fontSize: "16px",
    fontWeight: 700,
    marginBottom: "8px",
  },
  itemTitle: {
    fontSize: "16px",
    color: "#272522",
  },
  horizontalDivider: {
    width: "1.5px",
    background: "#C4C4C4",
  },
  dataContainer: {
    display: "flex",
    gap: ({ isDesktop }) => (isDesktop ? "16px" : "40px"),
  },
  sentTo: {
    color: "#493AB1",
  },
  openedBy: {
    color: "#00B77A",
  },
  openedRate: {
    color: "#0052CC",
  },
  dark: {
    background: "#F3F2F1",
  },
  mobileRoot: {
    display: "block",
  },
  mobileHeader: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1.5px solid #E7E6E4",
    paddingBottom: "10px",
    marginBottom: "10.5px",
  },
  headerLeftContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  moreIcon: {
    padding: 0,
    marginRight: "16px",
    color: theme?.palette?.primary?.main,
  },
  mobileFooter: {
    background: "#EEECF9",
    borderRadius: "0px 0px 5px 5px",
    margin: "0px -1.5px -17.5px -13.5px",
    padding: "12px",
  },
  paperClassName: {
    padding: "16px",
  },
  option: {
    fontSize: "16px",
    marginBottom: "14px",
  },
}));
